<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 日次入退場状況検索条件の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>日次入退場状況検索条件の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/select-entrance-exit-transit-daily-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png">閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png">検索条件
        </div>
        <div class="manual-explain">
          イベント：<br>
          イベントを選択します。<br>
          来場日：開始日 - 終了日：<br>
          来場日を範囲で設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png">検索ボタン
        </div>
        <div class="manual-explain">
          検索条件に設定された内容で日次入退場状況を検索します。<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Daily Entry/Exit Status Search Conditions
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Daily Entry/Exit Status Search Conditions</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_select-entrance-exit-transit-daily-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Search Conditions
        </div>
        <div class="manual-explain">
          Event:<br>
          Select an event.<br>
          Visit Date: Start Date - End Date:<br>
          Set the visit date range.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Search Button
        </div>
        <div class="manual-explain">
          Search for daily entry/exit status with the content set in the search conditions.<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
